const dashboard = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboards/Dashboard.vue'),
    meta: {
      layout: 'content',
      resource: 'Public',
    },
  },

  /* {
    path: '/dashboards/analytics',
    name: 'dashboard-analytics',

    component: () => import('@/views/dashboards/analytics/Analytics.vue'),

    /!* component: () => import('@/views/dashboards/UnderMaintenance.vue'), *!/
    meta: {
      layout: 'content',
      resource: 'Public',
    },
  },
  {
    path: '/dashboards/eCommerce',
    name: 'dashboard-eCommerce',

    /!* component: () => import('@/views/dashboards/ecommerce/Ecommerce.vue'), *!/
    component: () => import('@/views/dashboards/UnderMaintenance.vue'),
    meta: {
      layout: 'content',
    },
  }, */
]

export default dashboard
